/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Downloads_DescriptionInputs */

const en_meta_downloads_description = /** @type {(inputs: Meta_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevate your study game by downloading the Listening app, transforming research papers into audio. Get started now!`)
};

const es_meta_downloads_description = /** @type {(inputs: Meta_Downloads_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora tu estudio descargando la app Listening, transformando artículos de investigación en audio. ¡Comienza ahora!`)
};

/**
* | output |
* | --- |
* | "Elevate your study game by downloading the Listening app, transforming research papers into audio. Get started now!" |
*
* @param {Meta_Downloads_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_downloads_description = /** @type {((inputs?: Meta_Downloads_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Downloads_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_downloads_description(inputs)
	return en_meta_downloads_description(inputs)
});